<template>
  <div class="row justify-end">
    <vs-button
      class="mt-5 mr-5"
      data-cy="cancel"
      @click="back"
      color="primary"
      :disabled="saving"
    >
      Cancelar
    </vs-button>
    <vs-button
      data-cy="save-draft"
      class="mr-5 mt-5 btn btn-secondary"
      @click="saveDraft"
      size="sm"
      v-has-permission="'ED276'"
      :disabled="saving || disabled"
    >
      Guardar borrador
      <span v-show="saving" class="spinner-border spinner-border-sm text-primary" />
    </vs-button>
    <vs-button
      class="mt-5 mr-5"
      data-cy="preview"
      @click="preview"
      color="warning"
      :disabled="saving"
    >
      Previsualizar
      <span v-show="saving" class="spinner-border spinner-border-sm text-primary" />
    </vs-button>
    <vs-button
      class="mt-5 mr-5"
      data-cy="save"
      @click="save"
      color="success"
      :disabled="saving"
    >
      Crear
      <span v-show="saving" class="spinner-border spinner-border-sm text-primary" />
    </vs-button>
  </div>
</template>

<script>
export default {
  name: 'FormActionButtons',
  props: {
    disabled: { type: Boolean, default: false },
    saving: Boolean,
    preview: Function,
    back: Function,
    save: Function,
    saveDraft: Function,
  },
};
</script>
